import component from './searchInput.component';

const module = angular.module('searchInput', [])
	.component('searchInput', component)
	.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/searchInput/searchInput.js